import type { BehaviorModuleConfig } from '../../types/modules/behavior';

export const DEFAULT_BEHAVIOR_MODULE_CONFIG: BehaviorModuleConfig = {
  enabled: false,

  heartbeat: {
    enabled: false,
    intervalMs: 15_000,
    hiddenIntervalMs: 60_000,
    emitWhenHidden: false,
    emitWhenIdle: true,
    includeSnapshot: true,
    fireImmediately: false,
  },

  engagement: {
    enabled: false,
    evaluationIntervalMs: 5_000,
    emitOnChange: true,
    minScoreDelta: 5,
    emitSummaryOnDestroy: true,

    weights: {
      activeTime: 0.25,
      scroll: 0.2,
      click: 0.15,
      viewport: 0.2,
      visibility: 0.1,
      heartbeat: 0.1,
    },

    penalties: {
      idle: 0.2,
      rageClick: 0.1,
    },

    thresholds: {
      lowMax: 29,
      mediumMax: 69,
    },
  },

  rateLimit: {
    enabled: false,
    windowMs: 1_000,
    maxSignalsPerWindow: 50,
    criticalBypass: true,
  },

  buffer: {
    enabled: false,
    maxSize: 200,
    maxAgeMs: 30_000,
    flushSize: 50,
    dropStrategy: 'compress_similar',
    flushOnHidden: true,
  },

  stateMachine: {
    enabled: false,
    historyLimit: 50,
  },

  sessionSummary: {
    enabled: false,
    emitOnHidden: false,
    emitOnDestroy: true,
    minimumSessionMs: 0,
  },

  trackers: {
    scroll: {
      enabled: false,
      thresholds: [25, 50, 75, 100],
      debounceMs: 100,
    },

    click: {
      enabled: false,
      rageClick: {
        enabled: true,
        threshold: 3,
        windowMs: 500,
      },
    },

    idle: {
      enabled: false,
      thresholdMs: 60_000,
    },

    visibility: {
      enabled: false,
    },

    exitIntent: {
      enabled: false,
    },

    viewport: {
      enabled: false,
      targets: [],
      rootMargin: '0px',
      observeMutations: true,
      mutationDebounceMs: 100,
      maxObservedElements: 500,
    },
  },
};
